import _ from 'lodash';
import { mapState } from 'vuex';
import { getGameType } from './getGameType';
import BillingBlockMixin from '../user/BillingBlockMixin';

const notAllowedRoutes = [
    'addition-and-subtraction-with-time:start',
    'multiplication-and-division:start',
    'addition-and-subtraction:start',
    'interactive-flash-cards:start',
    'flash-cards:start',
    'equation:start',
    'factorization:start',
    'equation-online:start',
    'anzan:start',
    'anzan-with-time:start',
    'puzzle:start',
    'couples:start',
    'chains:start',
    'schulte:start',
    'scanner:start',
    'schulte:start',
    'assemble-the-number:start',
    'words-field:start',
    'anagrams:start',
    'texts:start',
    'vision-field:start',
    'matrix:start',
    'navigator:start',
    'synonyms:start',
    'sequence-of-numbers:start',
    'who-is-who:start',
];

export default {
    mixins: [BillingBlockMixin],
    mounted() {
        if (this.blockedAccesses.includes(getGameType(this.slug))) {
            this.$router.push({ name: 'dashboard' });
        }
    },
    watch: {
        usersIds(value) {
            this.setInitParams(this.getKey(value));
        },
    },

    computed: {
        type() {
            switch (this.slug) {
                case 'MultiplicationAndDivision':
                    return 'MultiplicationAndDivision';
                case 'MultiplicationAndDivisionMathMagic':
                    return 'MultiplicationAndDivisionMathMagic';
                case 'AssembleTheNumber':
                    return 'AssembleTheNumber';
                case 'FlashCards':
                case 'InteractiveFlashCards':
                    return 'FlashCards';
                case 'SequenceOfNumbers':
                    return 'SequenceOfNumbers';
                case 'AdditionAndSubtraction':
                case 'AdditionAndSubtractionWithTime':
                    return 'AdditionAndSubtraction';
                case 'Equation':
                case 'EquationOnline':
                    return 'Equation';
                case 'Factorization':
                    return 'Factorization';
                case 'Anzan':
                case 'AnzanWithTime':
                    return 'Anzan';
                case 'Puzzle':
                    return 'Puzzle';
                case 'Couples':
                case 'CouplesWithTime':
                case 'CouplesMemoryDevelopment':
                case 'CouplesMemoryDevelopmentWithTime':
                    return 'Couples';
                case 'Chains':
                    return 'Chains';
                case 'Schulte':
                    return 'Schulte';
                case 'Scanner':
                case 'ScannerWithTime':
                    return 'Scanner';
                case 'WordsField':
                case 'WordsFieldWithTime':
                    return 'WordsField';
                case 'WordsFieldReadingEn':
                case 'WordsFieldReadingEnWithTime':
                    return 'WordsFieldReadingEn';
                case 'Anagrams':
                case 'AnagramsWithTime':
                    return 'Anagrams';
                case 'Texts':
                case 'TextsWithTime':
                case 'TextsOnline':
                    return 'Texts';
                case 'VisionField':
                    return 'VisionField';
                case 'Matrix':
                    return 'Matrix';
                case 'Memorize':
                    return 'Memorize';
                case 'Navigator':
                    return 'Navigator';
                case 'Synonyms':
                case 'SynonymsOnline':
                    return 'Synonyms';
                case 'revivedNumbers':
                    return 'revivedNumbers';
                case 'EducationMaterials':
                    return 'EducationMaterials';
                case 'WhoIsWho':
                case 'WhoIsWhoWithTime':
                    return 'WhoIsWho';
                case 'SecretsOfCicero':
                    return 'SecretsOfCicero';
                case 'CosmoTour':
                    return 'CosmoTour';
                case 'MentalDrawing':
                    return 'MentalDrawing';
                case 'HandsUp':
                    return 'HandsUp';
                case 'Chameleon':
                    return 'Chameleon';
                case 'RepeatAfterMe':
                    return 'RepeatAfterMe';
                case 'Loner':
                    return 'Loner';
                case 'CorrectiveSamples':
                case 'CorrectiveSamplesWithTime':
                    return 'CorrectiveSamples';
                case 'ChainsBonusGame':
                case 'ChainsBonusGameWithTime':
                case 'ChainsBonusGameWithoutTime':
                    return 'ChainsBonusGame';
                case 'SynonymsReadingEn':
                    return 'SynonymsReadingEn';
                case 'TransferSyllables':
                    return 'TransferSyllables';
                case 'TransferSyllablesSchoolPreparing':
                    return 'TransferSyllablesSchoolPreparing';
                case 'DivideItRight':
                    return 'DivideItRight';
                case 'ChooseItRight':
                    return 'ChooseItRight';
                case 'DivideUnstressedVowels':
                    return 'DivideUnstressedVowels';
                case 'WordStructure':
                    return 'WordStructure';
                case 'ShutterRussianLanguage':
                    return 'ShutterRussianLanguage';
                case 'SentenceParsing':
                    return 'SentenceParsing';
                case 'VocabularyWordsRus':
                    return 'VocabularyWordsRus';
                case 'WordDrum':
                    return 'WordDrum';
                case 'PartsOfSpeech':
                    return 'PartsOfSpeech';
                case 'ParsingSentencePartsSpeech':
                    return 'ParsingSentencePartsSpeech';
                case 'SortOneMany':
                    return 'SortOneMany';
                case 'GenericWords':
                    return 'GenericWords';
                case 'VerbTenses':
                    return 'VerbTenses';
                case 'VocabularyMemoRus':
                    return 'VocabularyMemoRus';
                case 'LettersSoundsSyllables':
                    return 'LettersSoundsSyllables';
                case 'SynonymsRussianLanguage':
                    return 'SynonymsRussianLanguage';
                case 'AntonymsRussianLanguage':
                    return 'AntonymsRussianLanguage';
                case 'HardSoftConsonants':
                    return 'HardSoftConsonants';
                case 'HardSoftConsonantsSchoolPreparing':
                    return 'HardSoftConsonantsSchoolPreparing';
                case 'TranscriptionInWord':
                    return 'TranscriptionInWord';
                case 'VoicedAndDeafConsonants':
                    return 'VoicedAndDeafConsonants';
                case 'PunctuationMarks':
                    return 'PunctuationMarks';
                default:
                    return this.slug;
            }
        },
        ...mapState({
            homework: state => state.trainer.homework,
            levels: state => {
                return state.olympiad.intermediateStage && state.olympiad.intermediateStage.levels;
            },
            battleLevels: state => {
                return state.battle.intermediateBattleStage && state.battle.intermediateBattleStage.levels;
            },
            puzzleGame: state => state.games.puzzle,
            prevRoute: state => state.router.previousRoute,
        }),
    },
    methods: {
        getKey(usersIds) {
            return usersIds ? 'usersU' + usersIds.join('U') : 'default';
        },
        cancel() {
            let isNotAllowedRoute = this.$store.state.router.previousRoute
                ? notAllowedRoutes.includes(this.$store.state.router.previousRoute.name)
                : true;
            this.$offline || isNotAllowedRoute ? this.$router.push({ name: 'trainer:games' }) : this.$router.back();
        },
        setInitParams(key) {
            if (this.levels) {
                this.stage = this.levels[+this.$route.params.index].stages[+this.$route.params.stageId];
            }
            if (this.battleLevels) {
                this.stage = this.battleLevels[+this.$route.params.index].stages[+this.$route.params.stageId];
            }
            let item = this.homework || this.stage || this.puzzleGame;
            if (this.gameMode === 'generator-settings') {
                item = this.puzzleGame;
            }
            let game = item ? item.games[this.id] : null;
            if (this.generatorSettings === 'generator-settings' && typeof this.generatorGameIndex === 'number') {
                game = game.parameters[key].games[this.generatorGameIndex];
            } else if (
                this.homework &&
                this.$route.params.individualGeneratorSettings === 'individualGeneratorSettings'
            ) {
                game = item.games[this.id].parameters.default.games[0];
            }
            if (game && game.parameters[key]) {
                this.params = _.cloneDeep(game.parameters[key]);
                if (Array.isArray(this.params)) {
                    this.paramsArray = this.params;
                    this.params = this.paramsArray[0];
                }
                if (!this.params.brothersAndFriendsOptions) {
                    this.$set(this.params, 'brothersAndFriendsOptions', {
                        onlySubtraction: false,
                        onlyAddition: false,
                    });
                }
                if (this.positions) {
                    this.selectedPosition = _.find(this.positions, { name: this.params.position });
                }
                if (this.difficult || this.slug === 'Texts') {
                    if (typeof this.params.difficult === 'number') {
                        this.selectedDifficult = _.find(this.difficult, { value: this.params.difficult });
                    } else if (this.slug !== 'Texts') {
                        this.selectedDifficult = _.find(this.difficult, { name: this.params.difficult });
                    }
                    if (this.gameMode !== 'course' && this.gamesParameters && this.gamesParameters[this.slug]) {
                        if (this.slug === 'AdditionAndSubtraction' || this.slug === 'AdditionAndSubtractionWithTime') {
                            this.brothersAndFriends = this.gamesParameters[this.slug].brothersAndFriends;
                            this.friends = this.gamesParameters[this.slug].friends;
                            this.brothers = this.gamesParameters[this.slug].brothers;
                        }
                        if (this.slug !== 'Texts') {
                            let difficultIndex = this.difficult
                                .map(difficulty => difficulty.value || difficulty.name)
                                .indexOf(this.gamesParameters[this.slug].difficult);
                            for (let i = difficultIndex + 1; i < this.difficult.length; i++) {
                                this.difficult[i].$isDisabled = true;
                            }
                            if (this.jumpOver) {
                                this.jumpOver.forEach(setting => {
                                    setting.$isDisabled = !_.some(
                                        this.gamesParameters[this.slug].jumpOver,
                                        elem => elem.value === setting.value
                                    );
                                });
                            }
                        } else if (Array.isArray(this.params.mode)) {
                            this.params.settings.withTime = false;
                            this.params.settings.allQuestions = false;
                            this.params.settings.withoutWord = false;
                            this.params.settings.endLetters = false;
                            this.params.settings.centralLetters = false;
                            this.params.settings.invertText = false;
                            this.params.settings.mirrorText = null;
                            this.params.settings.letters = 1;
                            this.params.settings.anagrams = null;
                        }
                    }
                }
            }
        },
        saveGameMode() {
            if (this.validateError() === false) return;
            if (this.params.dictation && !/^[1-9]\d*$/.test(this.params.timeForAnswer)) {
                this.$toasted.error(this.$i18n.t('errors.only_positive_timeForAnswer'));
                return;
            }
            if (
                this.params.difficult &&
                typeof this.params.difficult === 'object' &&
                (this.params.difficult.tens || this.params.difficult.hundreds || this.params.difficult.thousands)
            ) {
                if (this.params.difficult.digits) {
                    if (this.params.difficult.digits.length === 1) {
                        this.$toasted.error(this.$i18n.t('errors.incorrect_number_selected'));
                        return;
                    }
                } else {
                    this.$toasted.error(this.$i18n.t('errors.select_number_between'));
                    return;
                }
            } else if (
                this.params.game &&
                this.params.game.indexOf('FlashCards') !== -1 &&
                !_.values(this.params.difficult).filter(el => el).length
            ) {
                this.$toasted.error(this.$i18n.t('errors.select_at_least_one_option'));
                return;
            }
            this.paramsArray = this.paramsArray ? this.paramsArray : [];
            this.paramsArray.forEach(params => {
                params.slug = this.slug;
                params.courseType = this.courseType;
            });
            this.$store.dispatch('setGame', this.params);
            this.$store.dispatch('setParamsArray', this.paramsArray);
            let routeGameType =
                this.params &&
                this.params.withTime &&
                this.slug !== 'Couples' &&
                this.slug !== 'WhoIsWho' &&
                this.slug !== 'Chains' &&
                this.slug !== 'WordsFiled'
                    ? this.slug + 'WithTime'
                    : this.slug;
            this.$router.push({
                name: 'browse:game',
                params: {
                    type: routeGameType,
                    courseType: this.courseType,
                    sameSettingsAreActive: this.sameSettingsAreActive,
                },
            });
        },
        setGameInStorage() {
            let item = this.homework || this.stage || this.puzzleGame;
            item = _.cloneDeep(item);
            let key = this.usersIds ? 'usersU' + this.usersIds.join('U') : 'default';
            if (this.homework && this.paramsArray?.length > 1) {
                item.games[this.id].parameters[key] = _.cloneDeep(this.paramsArray);
            } else if (this.homework && this.gameMode === 'generator-settings') {
                this.puzzleGame.games[0].parameters[key] = _.cloneDeep(this.params);
                item.games[this.gameId].parameters[key] = _.cloneDeep(this.puzzleGame);
            } else if (
                this.homework &&
                this.$route.params.individualGeneratorSettings === 'individualGeneratorSettings'
            ) {
                item.games[this.id].parameters.default.games[0].parameters[key] = _.cloneDeep(this.params);
            } else if (this.generatorSettings === 'generator-settings' && (this.levels || this.battleLevels)) {
                item.games[this.id].parameters[key].games[this.generatorGameIndex].parameters.default = _.cloneDeep(
                    this.params
                );
            } else {
                item.games[this.id].parameters[key] = _.cloneDeep(this.params);
            }
            item.games[this.id].isEdited = true;
            if (this.puzzleGame && !this.homework) {
                this.$store.dispatch('setPuzzleGame', item);
            } else if (this.homework) {
                this.$store.dispatch('setHomework', item);
                this.$store.dispatch('setHomeworkCopy', item);
            } else if (this.levels) {
                this.levels[+this.$route.params.index].stages[+this.$route.params.stageId] = item;
            } else if (this.battleLevels) {
                this.battleLevels[+this.$route.params.index].stages[+this.$route.params.stageId] = item;
            }
        },
        saveGame() {
            if (this.validateError() === false) return;
            if (
                this.params.difficult &&
                typeof this.params.difficult === 'object' &&
                (this.params.difficult.tens || this.params.difficult.hundreds || this.params.difficult.thousands)
            ) {
                if (this.params.difficult.digits) {
                    if (this.params.difficult.digits.length === 1) {
                        this.$toasted.error(this.$i18n.t('errors.incorrect_number_selected'));
                        return;
                    }
                } else {
                    this.$toasted.error(this.$i18n.t('errors.select_number_between'));
                    return;
                }
            } else if (
                this.params.game &&
                this.params.game.indexOf('FlashCards') !== -1 &&
                !_.values(this.params.difficult).filter(el => el).length
            ) {
                this.$toasted.error(this.$i18n.t('errors.select_at_least_one_option'));
                return;
            }
            this.setGameInStorage();
            this.$router.back();
        },
        validateError() {
            let currentValidation = true;
            let group = [];
            group[0] = this.groupOne;
            group[1] = this.groupTwo;
            group[2] = this.groupThree;
            group[3] = this.groupFour;
            if (
                this.params['Группа 1 (ма, ро)'] ||
                this.params['Группа 2 (мя, ки)'] ||
                this.params['Группа 3 (ам, ор)'] ||
                this.params['Группа 4 (ям, ер)']
            ) {
                let groupsWithLettersSetting = [
                    'Группа 1 (ма, ро)',
                    'Группа 2 (мя, ки)',
                    'Группа 3 (ам, ор)',
                    'Группа 4 (ям, ер)',
                ];
                groupsWithLettersSetting.forEach((key, index) => {
                    if (this.params[key] && this.params[key].length > 0) {
                        let vowelLetters = group[index].slice(0, 5);
                        let consonantLetters = group[index].slice(5);
                        let presenceLetter = false;
                        vowelLetters.forEach(val => {
                            if (this.params[key].includes(val)) {
                                presenceLetter = true;
                            }
                        });
                        if (!presenceLetter) {
                            this.$toasted.error(this.$i18n.t('errors.need_select_vowel_letter'));
                            currentValidation = false;
                            return;
                        }
                        presenceLetter = false;
                        consonantLetters.forEach(val => {
                            if (this.params[key].includes(val)) {
                                presenceLetter = true;
                            }
                        });
                        if (!presenceLetter) {
                            this.$toasted.error(this.$i18n.t('errors.need_select_consonant_letter'));
                            currentValidation = false;
                            return;
                        }
                    }
                });
                return currentValidation;
            }
        },
        validate() {
            let trueParams = 0;
            for (let field in this.params.difficult) {
                if (this.params.difficult[field]) {
                    trueParams++;
                }
            }
            return trueParams;
        },
    },
    data() {
        return {
            stage: null,
        };
    },
};
